<div class="ps-card">
  <div class="ps-card-header">
    <div class="ps-card-heading">
      <span class="ps-card-icon"><ps-outline-icon name="clipboard"></ps-outline-icon></span>
      <div>
        <h2 class="ps-card-kicker">Commissioning</h2>
        <p class="ps-card-sub">Commissioning progress across checklists</p>
      </div>
    </div>
    <div class="ps-card-actions">
      <button class="ps-icon-btn" title="Project Dashboard" (click)="gotoCXPlannerDashboard()">
        <ps-outline-icon name="link"></ps-outline-icon>
      </button>
    </div>
  </div>

  <summary-gauge *ngIf="hasCommissioningStages" [percent]="commissioningOverallComplete" [display]="displayPercent"
    [statusLabel]="status.label" [badgeClass]="status.badgeClass" [gaugeColor]="status.gaugeColor"
    [isActive]="isActive" [playToken]="playToken"></summary-gauge>
</div>

<div class="ps-card" *ngIf="hasCommissioningStages">
  <div class="ps-section-title">Commissioning by Checklist</div>
  <div class="ps-scope" *ngFor="let stage of visibleStages">
    <button type="button" class="ps-scope-toggle" (click)="toggleStage(stage)">
      <ps-outline-icon [name]="isExpanded(stage) ? 'chevron-down' : 'chevron-right'"></ps-outline-icon>
      <span class="ps-scope-name">{{ stage.StageName }}</span>
      <span class="ps-scope-pct">{{ format(stage.PercentComplete, 0) }}</span>
    </button>
    <div class="ps-scope-bar-row">
      <div class="ps-bar" [ngClass]="tone(stage.PercentComplete)" [class.ps-run]="animateBars">
        <span [style.width]="stage.PercentComplete + '%'"></span>
      </div>
    </div>
    <div class="ps-scope-meta">
      <span>Progress</span>
      <span class="ps-scope-complete">{{ formatPrecise(stage.PercentComplete) }} Completion</span>
    </div>

    <div class="ps-phases" *ngIf="isExpanded(stage) && stage.Stages?.length">
      <div class="ps-phase" *ngFor="let child of stage.Stages">
        <div class="ps-phase-row">
          <span>{{ child.StageName }}</span>
          <span class="ps-phase-pct">{{ formatPrecise(child.PercentComplete) }}</span>
        </div>
        <div class="ps-bar is-thin" [ngClass]="tone(child.PercentComplete)" [class.ps-run]="animateBars">
          <span [style.width]="child.PercentComplete + '%'"></span>
        </div>
      </div>
    </div>
  </div>
  <button type="button" class="ps-link ps-view-all" *ngIf="stages.length > 3 && !showAllStages"
    (click)="showAllStages = true">
    View all checklists
    <ps-outline-icon name="chevron-down"></ps-outline-icon>
  </button>
</div>
